import { render } from "./JudgeMeLogoIcon.vue?vue&type=template&id=22292198"
import script from "./JudgeMeLogoIcon.vue?vue&type=script&lang=js"
export * from "./JudgeMeLogoIcon.vue?vue&type=script&lang=js"

import "./JudgeMeLogoIcon.vue?vue&type=style&index=0&id=22292198&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__